module.exports = __webpack_public_path__ + "d0458491dae1394c9f9252e126642da2.svg";